import React from 'react';
import { AccordionCustom } from '../../components/AccordionCustom';
import { H3 } from '../../components/H3';
import { Section } from '../../components/Section';
import { FAQ_DATA } from './constants';

export const FAQPage = () => {
  return (
      <div className="space-y-16 max-w-3xl m-auto">
        {FAQ_DATA.map((section, index) => (
            <Section key={index} className="md:ml-0 ml-3 -mx-5">
              <H3 className="font-semibold md:pb-8 pb-8 text-16 text-center">{section.title}</H3>
              {section.faqs.map((faq, index) => (
                  <AccordionCustom
                      key={index}
                      title={
                        <h1 className="font-normal text-13 md:font-normal px-3 py-3">
                          {faq.question}
                        </h1>
                      }
                      content={
                          <div
                              className="whitespace-pre-line text-gray-600 mt-1 md:p-3 text-12"
                              dangerouslySetInnerHTML={{ __html: faq.answer }}
                          />
                      }
                      defaultExpanded={false}
                  />
              ))}
            </Section>
        ))}
      </div>
  );
};
